import { UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { dropdownEndpoint } from "@/constants/api/dropdown";
import { ServerError, useGet } from "@/hooks";

export type DropdownOption = { name: string; value: string };
export type DropdownResponse = Record<string, DropdownOption[]>;

export const useDropDownOptions = ({
  options,
}: {
  options: UseQueryOptions<DropdownResponse, AxiosError<ServerError>, DropdownResponse>;
}) => {
  const {
    data: dropdownOptions = {},
    isLoading: isDropDownLoading,
    error: dropDownError,
  } = useGet<DropdownResponse, DropdownResponse>({
    endpoint: dropdownEndpoint.dropdown,
    options: {
      staleTime: 3600 * 24, // 24 hours
      ...options,
    },
  });

  return { dropdownOptions, isDropDownLoading, dropDownError };
};
